/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IWeight } from 'app/shared/model/weight.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface IPaediatricParams {
  id?: string;
  headCircumference?: number | null;
  midArmCircumference?: number | null;
  thumbGirth?: number | null;
  thumbLength?: number | null;
  thumbNailWidth?: number | null;
  subscapularSkinfold?: number | null;
  tricepsSkinfold?: number | null;
  notes?: string | null;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  weight?: IWeight;
  patient?: IGlucoUser | null;
}

export const defaultValue: Readonly<IPaediatricParams> = {
  active: false,
};
